var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShift4Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57007 0.136198L0.936686 8.65827C0.913653 8.70433 0.890625 8.72737 0.890625 8.77343V9.7408C0.890625 9.85596 0.982754 9.94809 1.09792 9.94809H7.04032C7.15548 9.94809 7.24761 10.0402 7.24761 10.1554V13.6103C7.24761 13.7254 7.33975 13.8176 7.45491 13.8176H8.7217C8.83686 13.8176 8.92899 13.7254 8.92899 13.6103V0.251361C8.92899 0.136198 8.83686 0.0440674 8.7217 0.0440674H7.75433C7.68523 0.0671 7.61614 0.090133 7.57007 0.136198ZM3.14781 8.10548L6.87909 3.33773C6.99426 3.1765 7.24761 3.26864 7.24761 3.4529V8.22065C7.24761 8.33581 7.15548 8.42794 7.04032 8.42794H3.30905C3.12478 8.45097 3.03265 8.24368 3.14781 8.10548Z",
    fill: "#090304"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShift4Logo);
export default __webpack_public_path__ + "static/media/IconShift4Logo.aa0ff3558dc866a3d5c22b84bc5937b4.svg";
export { ForwardRef as ReactComponent };